import { lazy } from "react";
import { Navigate } from "react-router-dom";

const BillingDetails = lazy(() => import("../components/BillingDetails").then((module) => ({ default: module.BillingDetails })));

const BillingConfigurationRoute = [
  {
    path: "cab-vendor/vendor/:id/billing-configuration",
    element: <BillingDetails />,
    name: "BillingDetails",
    index: 4,
    link: "cab-vendor/vendor/:id/billing-configuration",
    icon: "",
    superAdminView: false,
  },
  {
    path: "",
    element: <Navigate to="cab-vendor/vendor" replace />,
  },
];
export default BillingConfigurationRoute;
